module.exports = "<div class=\"wrapper wrapper-content\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"ibox float-e-margins\">\n        <div class=\"ibox-content\">\n          <course-evaluation></course-evaluation>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/marketplace/courseEvaluation/template.html
// module id = 1173
// module chunks = 0